import type { components } from 'wg-api-sdk';

import hasItems from '@/lib/utils/hasItems';

import RecommendationNotes from './RecommendationNotes';
import RecommendationTitle from './RecommendationTitle';

type Props = {
  recommendation: components['schemas']['OnesuranceRecommendation'];
};

export default function OtherRecommendation({ recommendation }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <RecommendationTitle recommendation={recommendation} />

      {hasItems(recommendation.notes) && (
        <div className="flex flex-col gap-2 text-xs">
          {recommendation.description && (
            <p className="text-muted-foreground">
              {recommendation.description}
            </p>
          )}

          <RecommendationNotes recommendation={recommendation} />
        </div>
      )}
    </div>
  );
}
